import { KakiMakanSectionAndSubSectionsUniqueNames } from "@config/kakiMakan";
import BHBasePage, { BHBasePageProps } from "@pages/BHBasePage";
import ErrorPage from "@pages/ErrorPage";
import { CasBannerWidget } from "@pages/Home/Components/CasBannerWidget";
import WidgetWrapper from "@pages/Home/HomePageLayout/WidgetWrapper";
import NotFound from "@pages/NotFound";
import type { TRouteWithoutRedirect } from "@sphtech/web2-core/ssr";
import { CustomContext, useRouteContext } from "@sphtech/web2-core/ssr";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

import KakiMakanRestaurants from "./Components/KakiMakanRestaurants";
import KakiMakanVideoSection from "./Components/KakiMakanVideoSection";
import { KakiMakanPayloadResponseType } from "./KakiMakan.server";
import KakiMakanMetaData from "./KakiMakanMetaData";

/**
 * KakiMakanSectionPage
 * Description: [Renders the Kaki Makan landing page with articles and video section]
 * @returns The rendered React element
 */
export function KakiMakanSectionPage() {
  const routeContext: CustomContext<
    TRouteWithoutRedirect<KakiMakanPayloadResponseType, string>
  > = useRouteContext();
  const dataLoaderResponse = routeContext.context;

  if (dataLoaderResponse.type === ResponseType.CLIENT_ERROR) {
    return <NotFound />;
  } else if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    return <ErrorPage message="Something went wrong" />;
  }

  const {
    data: kakiMakanArticles,
    initialRatings,
    kakiMakanBanner,
  } = dataLoaderResponse.payload;

  const SectionName = KakiMakanSectionAndSubSectionsUniqueNames[0];
  const pageAdTargetValue = PageAdTargetingTypeEnum.LISTING;
  const { gaData, metaTags } = KakiMakanMetaData();
  const basePageProps: BHBasePageProps = {
    metaTags,
    gaData: gaData,
    adsSectionName: SectionName,
    pageAdTargetValue: pageAdTargetValue,
    hideScrollableSectionMenu: true,
  };

  return (
    <BHBasePage {...basePageProps}>
      <WidgetWrapper>
        <div className="flex flex-col gap-4 bg-white-100">
          <CasBannerWidget CasBannerWidgetContent={kakiMakanBanner} />
          <div className="flex flex-col gap-4 p-1.5 lg:p-4 items-center">
            <KakiMakanRestaurants
              kakiMakanArticles={kakiMakanArticles}
              initialRatings={initialRatings}
            />
          </div>
          <KakiMakanVideoSection />
        </div>
      </WidgetWrapper>
    </BHBasePage>
  );
}
